<template>
<div class="video-outer" :class="outer_cls" :id="outer_id">
    
    <div class="debug" v-if="0">
      UID{{uid}} - {{outer_w}} x {{outer_h}}
    </div>
    
    <div class="video-inner" :style="inner_css" ref="inner">

      <iframe v-if="type == 'vimeo' "
          :id="id"
          :src="src_vimeo" 
          frameborder="0" 
          allow="autoplay; fullscreen" 
          allowfullscreen
      ></iframe>
      
      <iframe v-if="type == 'youtube' "
          :id="id"
          type="text/html" 
          width="100%" 
          height="100%"
          :src="src_youtube"
          allow="autoplay; fullscreen" 
          allowfullscreen
          autoplay
          frameborder="0"
      ></iframe>
      
    </div>
</div>
</template>

<script>
import mixins from '.././mixins.js'
export default {
  mixins: [ mixins.generic ],
  props: [
    'type', 
    'video_slug', 
    'blockmode',
    'responsiveblockmode',    
    'controls',
    'sound',
  ],
  data(){ return {
     
    uid:  undefined,
    outer_w: undefined, outer_h: undefined,
    settings: {
      controls: false,
      sound: false,
    },

  }},
  computed:{
    
    id(){ return 'videoembed_'+ this.video_slug + '_' + this.uid },
    outer_id(){ return 'videoembed_outer_'+ this.video_slug +'_'+this.uid },

    src_youtube(){
      
      var sound = 'mute=1'
      if( this.settings.sound === true ) sound = 'mute=0'
      
      var controls = 'controls=0'
      if( this.settings.controls === true ) controls = 'controls=1'
      
      var s = 'https://www.youtube.com/embed/'+ this.video_slug +'?autoplay=1&'+controls+'&loop=1&playlist='+ this.video_slug +'&'+sound+'&modestbranding=1&version=3&rel=0&showinfo=0&origin=' + this.site_base_url
      return s
    },

    src_vimeo(){
      
      var sound = 'muted=1'
      if( this.settings.sound === true ) sound = 'muted=0'
      
      var background = 'background=1'
      if( this.settings.controls === true ) background = 'background=0'

      var s = 'https://player.vimeo.com/video/'+ this.video_slug + '?autoplay=1&'+sound+'&loop=1&title=0&portrait=0&byline=0&title=0&autopause=0&'+background+'&quality=720p'
      return s
    },


    inner_css(){
      var css = {}

      if( this.blockmode === true ) return css
      if( this.responsiveblockmode === true ) return css

      css.width = '100%'
      css.height = '56.25%'

      if( this.outer_w && this.outer_h )  {

        var w = this.outer_w
        var h = this.outer_h

        var c_ratio1 = w / h
        var c_ratio2 = h / w

        var v_ratio1 = 1920 / 1080 // hardcoded - can we get dimensions from video?
        var v_ratio2 = 1080 / 1920 // hardcoded - can we get dimensions from video?
        
        var l = ( c_ratio1 > v_ratio1 )
        var p = !l

        if( p ) {
          css.width =  h * v_ratio1 + 'px'
          css.height = h + 'px'
        } else {
          css.height =  w + 'px'
          css.width = w * v_ratio1 + 'px'
        }

        return css

        if( c_l ) {
          css.width =  w + 'px'
          css.height = w * v_ratio1 + 'px'
        }

        if( c_p ) {
          css.height = h + 'px'
          css.width = h * v_ratio1 + 'px'          
        }

      }      

      return css
    },

    outer_cls(){
      var cls = {}
      cls['video-' + this.type] = true
      if( this.blockmode === true ) cls['blockmode'] = true
      if( this.responsiveblockmode === true ) cls['responsiveblockmode'] = true
      if( this.settings.controls === true ) cls['has-controls'] = true
      return cls
    },
    
  },
  methods: {
    
    onResize(){
      
      if( this.blockmode === true ) return
      if( this.responsiveblockmode === true ) return

      var el = document.getElementById(this.outer_id)
      if( el ) {
        var w = el.offsetWidth
        var h = el.offsetHeight
        if( w ) this.outer_w = w
        if( h ) this.outer_h = h
      }

    },
    
  },  
  mounted(){
    this.onResize()
  },
  created(){
    
    this.uid = parseInt(Math.random() * 9990)
    
    window.addEventListener('resize', this.onResize)

    if( this.controls !== undefined ) this.settings.controls = this.controls
    if( this.sound !== undefined ) this.settings.sound = this.sound

  },

  destroyed(){
    
    window.removeEventListener('resize', this.onResize)

  },


}
</script>


// WEBPACK FOOTER //
// src/components/VideoEmbed.vue